export default "__VITE_ASSET__BcMEyHcg__"